import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs';
import { NgrxService } from 'src/app/services/ngrx/ngrx.service';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class OpenDoorService {
	constructor(private http: HttpClient, private ngrxService: NgrxService) {}

	loadOpenDoorInit() {
		return this.ngrxService.loadInitAPI('OpenDoor', 'data');
	}

	loadOpenDoorAPI(status = 'Pending') {
		return this.loadOpenDoorData(status).pipe(
			map(data => this.ngrxService.loadInitData('OpenDoor', 'data', data)),
		);
	}

	fetchOpenDoorData() {
		return this.ngrxService.loadData('OpenDoor', 'data');
	}

	loadOpenDoorData(status = 'Pending') {
		return this.http
			.get(environment.url.profile + `/opendoor/climate/status/${status}`)
			.pipe(map(({ data }: any) => data));
	}

	loadOpenDoorUpdateAPI(id: number, status: string) {
		return this.http
			.put(
				environment.url.profile + `/opendoor/climate/${id}/status/${status}`,
				{ id, status },
			)
			.pipe(tap(() => this.loadOpenDoorAPI(status).subscribe()));
	}

	loadOpenDoorMeetUpdateAPI(id: number, status: boolean) {
		return this.http
			.put(
				environment.url.profile + `/profileid/${id}/availableForMeet/${status}`,
				{ id, status },
			)
			.pipe(tap(() => this.loadOpenDoorAPI('approved').subscribe()));
	}

	updateOnboardingFalse(user_id: string) {
		return this.http.post(
			environment.url.lookupBaseUrl +
				`lookup/users/onboarding-skip
			`,
			{
				user_id,
				onboardingStatus: false,
			},
		);
	}
}
